module.exports = __webpack_public_path__ + "4ceef251de275e930a2eef11c166112b.svg";